import React from "react";
import { Redirect, useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { useAuthContextV2 } from "../../../../../auth-state";
import { useServiceAccountCreatePage } from "../../../../../hooks/service-account/service-account-create";
import { ServiceAccountCreateButtons } from "../../../../organisms/service-account/service-account-create-buttons";
import { ServiceAccountCreateForm } from "../../../../organisms/service-account/service-account-create-form";
import { SettingsTemplate } from "../../../../template/settings/default-template";
import { SettingR } from "../../route";

export const ServiceAccountCreatePage: React.FC = () => {
  const { auth } = useAuthContextV2();

  if (!auth.hasPermissions("service_account.service_account.create")) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  return (
    <SettingsTemplate
      breadcrumbs={[
        {
          to: SettingR.ServiceAccounts.link({}),
          title: "サービスアカウント一覧",
        },
        { to: "#", title: "サービスアカウントの新規登録" },
      ]}
    >
      <h1 className="title">サービスアカウントの新規登録</h1>
      {auth.data?.orgId && <Content tenantId={auth.data.orgId} />}
    </SettingsTemplate>
  );
};

const Content: React.FC<{ tenantId: string }> = ({ tenantId }) => {
  const {
    input,
    setInput,
    createServiceAccount,
    isLoading,
    validationState,
    shouldDisplayError,
  } = useServiceAccountCreatePage({ tenantId });

  const history = useHistory();

  const handleCreate = React.useCallback(() => {
    createServiceAccount({
      onSucceeded: (serviceAccount) => {
        history.push(
          SettingR.ServiceAccountDetail.link({
            id: serviceAccount.id,
            isNewlyCreated: true,
          }),
        );
      },
      onFailed: (msg) => {
        toast.error(msg);
      },
    });
  }, [createServiceAccount, history]);

  const handleCancel = React.useCallback(() => {
    history.push(SettingR.ServiceAccounts.link({}));
  }, [history]);

  return (
    <>
      <ServiceAccountCreateButtons
        onCreate={handleCreate}
        onCancel={handleCancel}
        isLoading={isLoading}
      />
      <ServiceAccountCreateForm
        createServiceAccountInput={input}
        onChange={setInput}
        tenantId={tenantId}
        validationState={validationState}
        shouldDisplayError={shouldDisplayError}
      />
    </>
  );
};
